module.exports = __webpack_public_path__ + "static/media/male-customer-rate-and-tip_2x.1184aeb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/male-customer-rate-and-tip_2x.png
// module id = 1174
// module chunks = 27